module.exports = __webpack_public_path__ + "static/media/maps_ijo.7bcc5143.png";